import { ActivatedRoute, Data } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InitialData } from 'app/app.types';
import { SessionNavigationService } from 'app/shared/navigation/session-navigation.service';

export function bindLayoutInitialData(
    route: ActivatedRoute,
    sessionNavigation: SessionNavigationService,
    destroy$: Subject<unknown>,
    apply: (data: InitialData) => void
): void {
    route.data.pipe(takeUntil(destroy$)).subscribe((data: Data) => {
        const initial = data.initialData as InitialData | undefined;
        if (!initial) {
            return;
        }

        sessionNavigation.setBaseInitialData(initial);
        apply(sessionNavigation.getInitialData());
    });

    sessionNavigation.initialData$
        .pipe(takeUntil(destroy$))
        .subscribe((initial) => apply(initial));
}
